// extracted by mini-css-extract-plugin
module.exports = {"categoryBlock":"CategoryBlock_categoryBlock__2xSmp"};